import isIframeEmbed from 'bc-app/src/components/IframePresentation/isIframeEmbed';
import { socket } from 'bc-artifacts-client/api';

if (isIframeEmbed()) {
  socket.disconnect();
}

export type { ListenEvents, TypedSocket } from 'bc-artifacts-client/api';
export { socket };
